import colonyAPI from './colony';
import facebookAPI from './facebook';
import instagramAPI from './instagram';
import telegramAPI from './telegram';
import tiktokAPI from './tiktok';

export { colonyAPI, facebookAPI, instagramAPI, telegramAPI, tiktokAPI };



// WEBPACK FOOTER //
// ./src/api/index.js